import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import wrapComponent from "ApplicationWrapper"
import KitchenStation from "lib/auth/KitchenStation"

import ProtectedRoute from "ProtectedRoute"

import LoginView from "KDS/LoginView";
import StationView from "KDS/StationView";
import RecallPanel from "KDS/RecallPanel";
import SettingsView from "KDS/SettingsView";

import FourOhFour from "FourOhFour"

export default props => (
  <Router>
    <Switch>
      <Route path="/login" exact component={wrapComponent(LoginView, "Auth")} />

      <ProtectedRoute path="/" exact component={wrapComponent(StationView, "KDS")} auth={KitchenStation} />
      <ProtectedRoute path="/recall" exact component={wrapComponent(RecallPanel, "KDS")} auth={KitchenStation} />
      <ProtectedRoute path="/settings" exact component={wrapComponent(SettingsView, "KDS")} auth={KitchenStation} />

      <Route path="/*" component={wrapComponent(FourOhFour)} />
    </Switch>
  </Router>
);
